import React, { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import FolderIcon from "@mui/icons-material/Folder";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
import Button from "@mui/material/Button";
import { LocalizedLink } from "gatsby-plugin-i18n-l10n";
import { FormattedMessage, useIntl } from "react-intl";
import { StaticImage } from "gatsby-plugin-image";
import CtaButton from "./CtaButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { Popover } from "@mui/material";

const darkTheme = createTheme({ palette: { mode: "light", primary: { main: "#222" }, secondary: { main: "#fff" } } });

export default function MainNavigation(props: any) {
  const { position, windowWidth } = props;
  const [open, setState] = useState(false);

  // const [anchorElSubMenu1, setAnchorElSubMenu1] = useState<null | HTMLElement>(null);
  const [anchorElSubMenu, setAnchorElSubMenu] = useState<any>(false);
  const isSubMenuOpen = Boolean(anchorElSubMenu);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if(isSubMenuOpen){ setAnchorElSubMenu(null);}
    else{ setAnchorElSubMenu(event.currentTarget);}
  };
  
  const toggleDrawer = (open: any) => (event: any) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) { return; }
    setState(open);
  };


  useEffect(() => {
    console.log("anchorElSubMenu: ", anchorElSubMenu);
  }, [anchorElSubMenu]);

const SubMenu = ()=>
  <Popover
    id="fade-menu"
    // MenuListProps={{ "aria-labelledby": "fade-button" }} 
    anchorEl={anchorElSubMenu}
    open={isSubMenuOpen}
    // onClose={handleCloseSubMenu}
    TransitionComponent={Fade}
    style={{ width: "320px" }}
  >
    <MenuItem >
      <LocalizedLink to="/portfolio" className="subMenuItems">
        <FormattedMessage id="nav.portfolio" />{" "}
      </LocalizedLink>
    </MenuItem>
    <MenuItem >
      <LocalizedLink to="/referral" className="subMenuItems">
        <FormattedMessage id="nav.referrals" />{" "}
      </LocalizedLink>
    </MenuItem>
    <MenuItem >
      <LocalizedLink to="/governments-incentives-2025" className="subMenuItems">
        <FormattedMessage id="nav.governmentsIncentives" />{" "}
      </LocalizedLink>
    </MenuItem>
    {/* <MenuItem onClick={handleCloseSubMenu}>
      <LocalizedLink to="/faq" className="subMenuItems">
        <FormattedMessage id="nav.faq" />{" "}
      </LocalizedLink>
    </MenuItem>
    <MenuItem onClick={handleCloseSubMenu}>
      <LocalizedLink to="/careers" className="subMenuItems">
        <FormattedMessage id="nav.careers" />{" "}
      </LocalizedLink>
    </MenuItem>
    <MenuItem onClick={handleCloseSubMenu}>
      <LocalizedLink to="/financing" className="subMenuItems">
        <FormattedMessage id="nav.financing" />{" "}
      </LocalizedLink>
    </MenuItem> */}
  </Popover>;

  return (
    <ThemeProvider theme={darkTheme}>
      <AppBar position={position} color="primary" sx={position === "fixed" ? { height: "60px", paddingTop: "10px" } : { height: "40px" }}>
        <Container sx={{ width: "100% !important", maxWidth: "100% !important", padding: "0 !important" }} /*disableGutters="true"*/>
          <Toolbar sx={{ minHeight: "40px !important", padding: "0 !important" }}>
            <IconButton edge="start" color="inherit" aria-label="open drawer" onClick={toggleDrawer(true)} sx={{ mr: 2, display: { xs: "block", md: "none" }, padding: "3px" }}>
              <MenuIcon sx={{ fontSize: 40, marginLeft: "25px", marginTop: "-3px" }} />
            </IconButton>
            <Box sx={{ flexGrow: 1, display: { xs: "block", md: "none" } }}></Box>

            {/*NavBar Menu*/}
            <Box component={"div"} sx={{ display: { xs: "none", md: "contents" } }}>
              {/*           
            <Button color="inherit">Login</Button>
            <Typography variant="h6" component="div" sx={{ paddingRight:2 }}>News</Typography>
            <Typography variant="h6" component="div" sx={{ flexGrow: 5 }}>News</Typography> */}
              <ListItemButton sx={{ justifyContent: "center", width: "40px" }}>
                <LocalizedLink to="/" activeStyle={{ textDecoration: "none" }}>
                  <Box sx={{ textDecoration: "none", color: "white", textAlign: "center", width: "100%", paddingBottom: "6px", fontSize: "larger", fontWeight: 600 }}>
                    <FormattedMessage id="nav.homepage" />
                  </Box>
                </LocalizedLink>
              </ListItemButton>
              <ListItemButton sx={{ justifyContent: "center", width: "40px" }}>
                <LocalizedLink to="/solutions" activeStyle={{ textDecoration: "none" }}>
                  <Box sx={{ textDecoration: "none", color: "white", textAlign: "center", width: "100%", paddingBottom: "6px", fontSize: "larger", fontWeight: 600 }}>
                    <FormattedMessage id="nav.solutions" />
                  </Box>
                </LocalizedLink>
              </ListItemButton>
              <ListItemButton sx={{ justifyContent: "center", width: "60px" }}>
                <a style={{ textDecoration: "none", color: "#222" }} onClick={handleClick}>
                  <Box sx={{ textDecoration: "none", color: "white", textAlign: "center", width: "100%", paddingBottom: "6px", fontSize: "larger", fontWeight: 600 }}>
                    <FormattedMessage id="nav.resources" />
                    {anchorElSubMenu && <SubMenu/>}
                  </Box>
                </a>
              </ListItemButton>
              <ListItemButton sx={{ justifyContent: "center", width: "60px" }}>
                <LocalizedLink activeStyle={{ textDecoration: "none" }} to="/contact-us">
                  <Box sx={{ textDecoration: "none", color: "white", textAlign: "center", width: "100%", paddingBottom: "6px", fontSize: "larger", fontWeight: 600 }}>
                    <FormattedMessage id="nav.contact-us" />
                  </Box>
                </LocalizedLink>
              </ListItemButton>
              {/* <Button color="inherit">Login</Button> */}
            </Box>
            <Box sx={{ width: "310px" }}>
              <CtaButton windowWidth={windowWidth} />
            </Box>

            {/* <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}> Brand </Typography> */}

            <Drawer
              transitionDuration={750}
              anchor="left"
              open={open}
              onClose={toggleDrawer(false)}
              //@ts-ignore
              onOpen={toggleDrawer(true)}
            >
              {/*Drawer Menu*/}
              <Box sx={{ p: 2, height: 1, backgroundColor: "#222", width: "200px" }}>
                <Box sx={{ width: "100%", textAlign: "right" }}>
                  <IconButton sx={{ mb: 2 }}>
                    <CloseIcon onClick={toggleDrawer(false)} color="secondary" />
                  </IconButton>
                </Box>

                <Divider sx={{ mb: 2 }} />

                <Box sx={{ mb: 2 }}>
                  <ListItemButton sx={{ justifyContent: "left", width: "40px" }}>
                    <LocalizedLink to="/" activeStyle={{ textDecoration: "none" }}>
                      <Box sx={{ textDecoration: "none", color: "white", textAlign: "left", width: "100%" }}>
                        <FormattedMessage id="nav.homepage" />
                      </Box>
                    </LocalizedLink>
                  </ListItemButton>
                  <ListItemButton sx={{ justifyContent: "left", width: "40px" }}>
                    <LocalizedLink to="/solutions" activeStyle={{ textDecoration: "none" }}>
                      <Box sx={{ textDecoration: "none", color: "white", textAlign: "left", width: "100%" }}>
                        <FormattedMessage id="nav.solutions" />
                      </Box>
                    </LocalizedLink>
                  </ListItemButton>
                  <ListItemButton sx={{ justifyContent: "left", width: "60px" }}>
                    <a style={{ textDecoration: "none", color: "#222" }} onClick={handleClick}>
                      <Box sx={{ textDecoration: "none", color: "white", textAlign: "left", width: "100%" }}>
                        <FormattedMessage id="nav.resources" />
                        <SubMenu/>
                      </Box>
                    </a>
                  </ListItemButton>
                  <ListItemButton sx={{ justifyContent: "left", width: "60px" }}>
                    <LocalizedLink activeStyle={{ textDecoration: "none" }} to="/contact-us">
                      <Box sx={{ textDecoration: "none", color: "white", textAlign: "left", width: "100%" }}>
                        <FormattedMessage id="nav.contact-us" />
                      </Box>
                    </LocalizedLink>
                  </ListItemButton>
                </Box>
              </Box>
            </Drawer>
          </Toolbar>
        </Container>
      </AppBar>
    </ThemeProvider>
  );
}
